import React from "react";
import "../../../css/DesignSystem/Buttons/ButtonOutlinedWithIconSmall.css";

const ButtonOutlinedWithIconSmall = ({ children, onClick, disabled, buttonText, icon }) => {
  return (
        <button
            className={`button-outlined-with-icon-small ${disabled ? "disabled" : ""}`}
            onClick={onClick}   
            disabled={disabled}
        >
          {icon && <span className="button-icon">{icon}</span>}
          <div className="Content-small text-primary-1">{buttonText}</div>
        </button>
  );
}

export default ButtonOutlinedWithIconSmall;